export default __webpack_public_path__ + "static/button-action-do-dark-ceb1bfb74ea1d91eb52bd7fe38337d4455b19b498e2b7b9aaa508b018a012fb9.png";